module.exports = __webpack_public_path__ + "img/bb_g1_t_ears-04.97e2cdb5.svg";